import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
   name: 'user',
   initialState: {
      firstName: '',
      lastName: '',
      id: '',
      email: '',
      phone: ''
    },
   reducers: {
      // setUserState: (state, action) => {
      //    Object.keys(action.payload).forEach((key)=>{
      //       state[key] = action.payload[key]
      //    })
      // }
      setUserState: (state, action) => {
         if (action.payload) {
            return {
               ...state,
               ...action.payload
            }
         }
         return state
      }
   }
})

export const { setUserState } = userSlice.actions

export default userSlice.reducer